import type { FortuneIconProps } from '@/app_components/icons/constants';

export const ButtonLeft = ({ className, ...props }: FortuneIconProps) => {
  return (
    <svg
      className={className}
      fill='none'
      height='12'
      viewBox='0 0 7 12'
      width='7'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <title>Left Arrow Button Icon</title>
      <path
        d='M6 11L1 6L6 1'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.25'
      />
    </svg>
  );
};
